import React from 'react';
import { PageContainer } from '@ant-design/pro-layout';
import { Link, useHistory } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Breadcrumb, Card, message } from 'antd';
import moment from 'moment';
import { Main } from 'components/layout';
import { useLoading, useQueryParams } from 'hooks';
import { GET_PROJECT_APPLICATION_SETTING } from 'gql/projectApplicationSetting';
import { GET_ME } from 'gql/auth';
import {
  ADD_PROJECT_APPLICATION,
  GET_MY_PROJECT_APPLICATIONS,
} from 'gql/projectApplications';
import ProjectApplicationStep from './ProjectApplicationStep';
import FundingDetail from './FundingDetail';
import ProjectApplicationForm from './ProjectApplicationForm';

const ApplyProjectApplication = () => {
  const queryParams = useQueryParams();
  const history = useHistory();
  const settingId = queryParams?.get('settingId');
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION_SETTING, {
    variables: { id: settingId },
  });
  const { data: meData, loading: meLoading } = useQuery(GET_ME);
  const [addProjectApplication, { loading: addLoading }] = useMutation(
    ADD_PROJECT_APPLICATION,
    {
      refetchQueries: [{ query: GET_MY_PROJECT_APPLICATIONS }],
    }
  );
  useLoading(addLoading);
  const initialValues = {
    refNumber: 'Auto-generated by system',
    team: [
      {
        user: meData?.me?.id,
        name: meData?.me?.name,
        department: meData?.me?.department?.id,
        position: meData?.me?.userFromHroStaff?.position,
        email: meData?.me?.email,
        netId: meData?.me?.netId,
      },
    ],
  };
  const onFinish = async (values) => {
    delete values.refNumber;
    const input = {
      ...values,
      startDate: values.startDate
        ? moment(values.startDate).format('YYYY-MM-DD')
        : null,
      endDate: values.endDate
        ? moment(values.endDate).format('YYYY-MM-DD')
        : null,
      proposal: values.proposal?.[0]?.id,
      setting: settingId,
    };
    const { data } = await addProjectApplication({
      variables: {
        input,
      },
    });
    message.success('Funding application saved successfully');
    history.push({
      pathname: `/project-applications/${data?.addProjectApplication?.id}`,
      search: '?action=submit',
    });
  };
  const onSave = async (form) => {
    const values = form.getFieldsValue();
    delete values.refNumber;
    const input = {
      ...values,
      startDate: values.startDate
        ? moment(values.startDate).format('YYYY-MM-DD')
        : null,
      endDate: values.endDate
        ? moment(values.endDate).format('YYYY-MM-DD')
        : null,
      proposal: values.proposal?.[0]?.id,
      setting: settingId,
    };
    await addProjectApplication({
      variables: {
        input,
      },
    });
    message.success('Funding application saved successfully');
    history.push('/project-applications/my');
  };
  return (
    <Main>
      <PageContainer
        ghost
        loading={loading || meLoading}
        header={{
          title: 'Submit Funding Application',
          breadcrumb: (
            <Breadcrumb style={{ marginBottom: '16px' }}>
              <Breadcrumb.Item>
                <Link to="/project-applications/fundings">
                  Funding Applications
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {data?.projectApplicationSetting?.title ||
                  'Submit Funding Application'}
              </Breadcrumb.Item>
            </Breadcrumb>
          ),
        }}
      >
        <Card>
          <ProjectApplicationStep current={0} />
          <FundingDetail data={data?.projectApplicationSetting} />
          <ProjectApplicationForm
            initialValues={initialValues}
            loading={meLoading || loading}
            onFinish={onFinish}
            onSave={onSave}
          />
        </Card>
      </PageContainer>
    </Main>
  );
};

ApplyProjectApplication.propTypes = {};

export default ApplyProjectApplication;
